import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import RadioGroup from "Shared/RadioGroup";
import RadioInput from "Shared/RadioGroup/RadioInput";
import { PaymentTypeOptions } from "Types/state";
import CalculatorRow from "../CalculatorRow";
import { PaymentTypeDisplayMatrix, paymentTypeValues } from "./lib";

interface PaymentTypeProps {
    enabledPayments: PaymentTypeDisplayMatrix;
    selectedPayment?: PaymentTypeOptions;
    onChange(value: PaymentTypeOptions): void;
}

class PaymentType extends Component<PaymentTypeProps & WithTranslation> {
    public render() {
        const displayMatrix: PaymentTypeDisplayMatrix = this.props.enabledPayments;
        const { t } = this.props;
        return (
            <CalculatorRow className="CalculatorRow__paymentType" title={t("CustomizePayment.PaymentType.title")}>
                <div data-e2e="paymentTypeOptions">
                    <RadioGroup onChange={this.handlePaymentTypeChange} name="paymentType">
                        {displayMatrix.loan && (
                            <RadioInput
                                label={t("CustomizePayment.PaymentType.finance")}
                                id="loan"
                                value="loan"
                                isDefault={this.props.selectedPayment === "loan"}
                            />
                        )}
                        {displayMatrix.lease && (
                            <RadioInput
                                label={t("CustomizePayment.PaymentType.lease")}
                                id="lease"
                                value="lease"
                                isDefault={this.props.selectedPayment === "lease"}
                            />
                        )}
                        {displayMatrix.cash && (
                            <RadioInput
                                label={t("CustomizePayment.PaymentType.cash")}
                                id="cash"
                                value="cash"
                                isDefault={this.props.selectedPayment === "cash"}
                            />
                        )}
                    </RadioGroup>
                </div>
            </CalculatorRow>
        );
    }

    private handlePaymentTypeChange = (name: string, value: string) => {
        if (paymentTypeValues.findIndex((t) => t === value) > -1) {
            this.props.onChange(value as PaymentTypeOptions);
        }
    };
}

export default withTranslation()(PaymentType);
